import React from 'react';
import { classNames } from '../helpers/functions';
import { AvatarGenerated } from '../Avatar';

const AssetHolder = ({ asset, i = 0 }) => {
	return (
		<div class={`group relative flex z-${10 - i}`}>
			<AvatarGenerated
				id={asset?.id}
				size="xxs"
				type="asset"
				className={classNames(
					'h-6 w-6 rounded-full ring-2 ring-white',
					`z-${10 - i}`
				)}
			/>
			<span
				class={`absolute top-7 left-4 scale-0 transition-all rounded p-2 text-xs group-hover:scale-100 z-${
					10 - i
				}  whitespace-nowrap border px-3 left-0 bg-white`}
			>
				<div>
					{`${asset?.manufacturerName || asset?.manufacturer?.name} ${
						asset?.modelName || asset?.model?.name
					}`}{' '}
				</div>
				<div className="text-gray-500 text-xxs">{`S/N: ${asset?.serialNumber}`}</div>
			</span>
		</div>
	);
};

export default AssetHolder;
